// 📧 SERVICIO DE ACCIONES DE EMAIL Y CARPETAS

// Función para obtener configuración de email
const getEmailConfig = () => {
  const savedConfig = localStorage.getItem('emailConfig');
  if (!savedConfig) {
    throw new Error('No se encontró configuración de email. Configure su cuenta primero.');
  }
  return JSON.parse(savedConfig);
};

// 🗑️ ELIMINAR EMAILS
export const deleteEmails = async (
  emailUids: number[],
  folderPath: string,
  permanent: boolean = false
): Promise<{ success: boolean; message: string; deletedCount?: number }> => {
  try {
    const config = getEmailConfig();

    const response = await fetch('https://backend.anubisai.net/api/pmail/delete-emails', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        server: config.server,
        username: config.username,
        password: config.password,
        imapPort: config.imapPort,
        ssl: config.ssl,
        folderPath: decodeURIComponent(folderPath),
        emailUids,
        permanent
      })
    });

    const result = await response.json();

    if (response.ok && result.success) {
      return {
        success: true,
        message: result.message,
        deletedCount: result.deletedCount
      };
    } else {
      throw new Error(result.error || 'Error al eliminar emails');
    }
  } catch (error: any) {
    console.error('Error deleting emails:', error);
    return {
      success: false,
      message: error.message
    };
  }
};

// 📁 MOVER EMAILS
export const moveEmails = async (
  emailUids: number[],
  sourceFolderPath: string,
  destinationFolderPath: string
): Promise<{ success: boolean; message: string; movedCount?: number }> => {
  try {
    const config = getEmailConfig();

    const response = await fetch('https://backend.anubisai.net/api/pmail/move-emails', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        server: config.server,
        username: config.username,
        password: config.password,
        imapPort: config.imapPort,
        ssl: config.ssl,
        sourceFolderPath: decodeURIComponent(sourceFolderPath),
        destinationFolderPath: decodeURIComponent(destinationFolderPath),
        emailUids
      })
    });

    const result = await response.json();

    if (response.ok && result.success) {
      return {
        success: true,
        message: result.message,
        movedCount: result.movedCount
      };
    } else {
      throw new Error(result.error || 'Error al mover emails');
    }
  } catch (error: any) {
    console.error('Error moving emails:', error);
    return {
      success: false,
      message: error.message
    };
  }
};

// ⭐ TOGGLE STAR
export const toggleEmailStar = async (
  emailUids: number[],
  folderPath: string,
  starred: boolean
): Promise<{ success: boolean; message: string; emailCount?: number }> => {
  try {
    const config = getEmailConfig();

    const response = await fetch('https://backend.anubisai.net/api/pmail/toggle-star', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        server: config.server,
        username: config.username,
        password: config.password,
        imapPort: config.imapPort,
        ssl: config.ssl,
        folderPath: decodeURIComponent(folderPath),
        emailUids,
        starred
      })
    });

    const result = await response.json();

    if (response.ok && result.success) {
      return {
        success: true,
        message: result.message,
        emailCount: result.emailCount
      };
    } else {
      throw new Error(result.error || 'Error al cambiar estado de estrella');
    }
  } catch (error: any) {
    console.error('Error toggling star:', error);
    return {
      success: false,
      message: error.message
    };
  }
};
